type NormalizeFeeNumberOptions = {
  allowDecimal: boolean;
  maxDecimalPlaces?: number;
};

const normalizeFeeNumberInput = (
  value: string,
  { allowDecimal, maxDecimalPlaces }: NormalizeFeeNumberOptions
): string => {
  if (value === '') {
    return value;
  }

  let normalizedValue = value;

  if (allowDecimal && normalizedValue.startsWith('.')) {
    normalizedValue = `0${normalizedValue}`;
  }

  if (allowDecimal && normalizedValue.includes('.')) {
    const [rawWholePart, ...fractionParts] = normalizedValue.split('.');
    const wholePart = rawWholePart.replace(/^0+(?=\d)/, '') || '0';
    const fractionPart = fractionParts.join('.').replace(/\./g, '');

    if (maxDecimalPlaces === 0) {
      return wholePart;
    }

    const trimmedFractionPart =
      typeof maxDecimalPlaces === 'number'
        ? fractionPart.slice(0, maxDecimalPlaces)
        : fractionPart;

    return `${wholePart}.${trimmedFractionPart}`;
  }

  return normalizedValue.replace(/^0+(?=\d)/, '');
};

export const normalizeFeeQuantityInput = (value: string): string =>
  normalizeFeeNumberInput(value, { allowDecimal: true, maxDecimalPlaces: 2 });

export const normalizeFeeUnitPriceInput = (value: string): string =>
  normalizeFeeNumberInput(value, { allowDecimal: true, maxDecimalPlaces: 2 });
